// extracted by mini-css-extract-plugin
export default {"main":"main--KGwYj","content":"content--UJm2b"};